import { Box, keyframes, type SxProps, type Theme } from '@mui/material';

import { mergeSx } from '../../../../utils/styles';

const pulse = keyframes({
  '0%, 100%': { opacity: 1 },
  '50%': { opacity: 0.3 },
});

type LiveDotProps = {
  size?: number;
  color?: string;
  sx?: SxProps<Theme>;
};

const LiveDot = ({ size = 8, color = 'error.main', sx }: LiveDotProps) => (
  <Box
    sx={mergeSx(
      {
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        flexShrink: 0,
        animation: `${pulse} 1.5s ease-in-out infinite`,
      },
      sx,
    )}
  />
);

export default LiveDot;
